import useApiService from "./useApiService";

const useCompany = () => {
  const { get, post, put } = useApiService();

  const fetchAllCompanies = async () => {
    try {
      const response = await get("/api/companies");
      if (response.status && response.data) {
        return { companies: response.data };
      } else {
        throw new Error("Unable to fetch companies");
      }
    } catch (error) {
      return { error };
    }
  };

  const getAllCompaniesWithNameAndLogo = async () => {
    const { companies, error } = await fetchAllCompanies();
    if (error) return { error };
    return {
      companies: companies.map((company) => ({
        id: company.id,
        name: company.name,
        logo_id: company.logo_file.id,
        logo: company.logo_file.url,
      })),
    };
  };

  const addNewCompany = async (companyData) => {
    try {
      const response = await post("/api/companies", companyData);
      if (response.status && response.data) {
        return { company: response.data };
      } else {
        throw new Error("Unable to add new company");
      }
    } catch (error) {
      return { error };
    }
  };

  const updateCompany = async (id, data) => {
    try {
      const response = await put(`/api/companies/${id}`, data);
      if (response.status && response.data) {
        return { company: response.data };
      } else {
        throw new Error("Unable to update project owner");
      }
    } catch (error) {
      return { error };
    }
  };

  return {
    fetchAllCompanies,
    getAllCompaniesWithNameAndLogo,
    addNewCompany,
    updateCompany,
  };
};

export default useCompany;
